import _ from "underscore";


function closestPolyfill(element, selector) {
    var currentElement = element;

    while (currentElement) {
        if (matches(currentElement, selector)) {
            return currentElement;
        }

        currentElement = currentElement.parentElement;
    }

    // if we reach here, we're never going to find it
    return null;
}

function matchesPolyfill(element, selector) {
    var parent = element.parentElement;
    var tmpParent;

    if (!parent) {
        tmpParent = document.createElement("div");
        tmpParent.appendChild(element);
        parent = tmpParent;
    }

    var result = _.contains(parent.querySelectorAll(selector), element);

    if (tmpParent) {
        tmpParent.removeChild(element);
        tmpParent = null;
    }

    return result;
}

/**
 * Polyfill for Element.prototype.matches
 *
 * @param {HTMLElement} element - the element to match against
 * @param {string} selector - the selectors to match
 */
function matches(element, selector) {
    var nativeMatches =
        element.matches ||
        element.matchesSelector ||
        element.webkitMatchesSelector ||
        element.mozMatchesSelector ||
        element.msMatchesSelector;

    if (nativeMatches) {
        return nativeMatches.call(element, selector);
    }

    return matchesPolyfill(element, selector);
}

export default {
    /**
     * Find the closest parent node that matches the selector, or itself. Use this to
     * ensure you have the correct element you want to query, or a specific parent.
     *
     * This exists due to cross platform reasons, when `element.closest` is supported
     * cross browser, that should be used.
     * @param {HTMLElement} element - the element to search from
     * @param {string} selector - the selector to find
     */
    closest: function(element, selector) {
        if (element.closest) {
            return element.closest(selector);
        }

        return closestPolyfill(element, selector);
    },

    /**
     * Polyfill for Element.prototype.matches
     *
     * @param {HTMLElement} element - the element to match against
     * @param {string} selector - the selectors to match
     */
    matches: matches,

    /**
     * Returns true if `a` and `b` are equal or `b` is contained by `a`.
     * @param {HTMLElement} a
     * @param {HTMLElement} b
     * @returns {Boolean}
     */
    contains(a, b) {
        if (a.contains) {
            return a.contains(b);
        }

        // yay a bitmask API
        return a === b || a.compareDocumentPosition(b) & document.DOCUMENT_POSITION_CONTAINED_BY;
    },

    // exposed for testing
    _closestPolyfill: closestPolyfill,
    _matchesPolyfill: matchesPolyfill,
};
